const messages = {
  threads: {
    orders: { title: "", content: "" },
    externalTraining: { title: "", content: "" },
    InvestmentSupport: { title: "", content: "" },
    onlineTraining: { title: "", content: "" },
    bTraining: { title: "", content: "" },
    hunter: { title: "", content: "" },
    profileComplete: { title: "", content: "" },
    activeUser: { title: "", content: "" },
    deleteItemFromOrder: { title: "", content: "" },
    deleteOrder: { title: "", content: "" },
    commitmentLetter: {
      title: "Benvenuto in BRIDGESTONE PLUS",
      content:
        "Gentile,<br/>Benvenuto! Siamo felici di informarti che da oggi potrai accedere liberamente in BRIDGESTONE PLUS e navigare attraverso le tue applicazioni Bridgestone a cui hai già accesso.<br/>Con l'augurio di poter sviluppare ulteriormente la nostra collaborazione, ti invitiamo ad esplorare tutte le funzionalità di BRIDGESTONE PLUS e contattarci in caso di approfondimenti o domande.<br/>Cordialmente,<br/>Il team Bridgestone",
    },
    uberall: { title: "", content: "" },
    welcome: {
      title: "Benvenuto in BRIDGESTONE PLUS",
      content:
        "Gentile,<br/>Benvenuto! Siamo felici di informarti che da oggi potrai accedere liberamente in BRIDGESTONE PLUS e navigare attraverso le tue applicazioni Bridgestone a cui hai già accesso.<br/>Con l'augurio di poter sviluppare ulteriormente la nostra collaborazione, ti invitiamo ad esplorare tutte le funzionalità di BRIDGESTONE PLUS e contattarci in caso di approfondimenti o domande.<br/>Cordialmente,<br/>Il team Bridgestone",
    },
    booster: { title: "", content: "" },
    orderStatus_RETURNED: { title: "", content: "" },
    orderStatus_REJECTED: { title: "", content: "" },
    kickbackPayback: { title: "", content: "" },
    survey_thankyou: { title: "", content: "" },
    survey: { title: "", content: "" },
    salesPromotions: { title: "", content: "" },
  },
};

export default {
  messages,
};
